import _ from 'lodash';

const earthRadius = 6378137;
const toRadius = (value) => (value * Math.PI) / 180;
const distanceConversion = { mi: 1 / 1609.344, km: 0.001 };
const convertDistance = (meters, targetUnit) => distanceConversion[targetUnit] * meters;

export const getDistance = ({ from, to, unit }) => {
  const distance =
    Math.acos(
      Math.sin(toRadius(to.latitude)) * Math.sin(toRadius(from.latitude)) +
        Math.cos(toRadius(to.latitude)) *
          Math.cos(toRadius(from.latitude)) *
          Math.cos(toRadius(from.longitude) - toRadius(to.longitude))
    ) * earthRadius;
  const value1 = convertDistance(distance, unit);
  const value = value1 < 100 ? value1?.toFixed(1) : Math.round(value1);
  return value;
};

const getSiteDistance = ({ latitude, longitude, coordinates, unit }) => {
  let distance = null;
  if (unit && coordinates && latitude !== null && longitude !== null)
    distance = getDistance({ unit, from: coordinates, to: { longitude, latitude } });
  return _.isNaN(distance) ? null : distance;
};

const getLatestCoordinates = () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        resolve({ latitude: coords.latitude, longitude: coords.longitude });
      },
      (error) => {
        reject(error);
      },
      {
        // enableHighAccuracy: false,
        enableHighAccuracy: true,
        timeout: 5000, // 60 seconds
        maximumAge: Infinity
      }
    );
  });
};

const getLatestCoordinatesUsingWatch = () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.watchPosition(
      ({ coords }) => {
        resolve({ latitude: coords.latitude, longitude: coords.longitude });
      },
      (error) => {
        reject(error);
      },
      {
        enableHighAccuracy: false,
        timeout: 5000, // 60 seconds
        maximumAge: 0
      }
    );
  });
};

const calculateDistance = (coord1, coord2) => {
  const R = 6371e3; // Radius of Earth in meters
  const toRadians = (degrees) => (degrees * Math.PI) / 180;

  const lat1 = toRadians(coord1.latitude);
  const lat2 = toRadians(coord2.latitude);
  const deltaLat = toRadians(coord2.latitude - coord1.latitude);
  const deltaLon = toRadians(coord2.longitude - coord1.longitude);

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distance in meters
};

export { getSiteDistance, getLatestCoordinates, calculateDistance, getLatestCoordinatesUsingWatch };
